import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { styled } from '@material-ui/styles'
import { FC, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-final-form'
import Autocomplete from '../../../control/autocomplete/autocomplete'
import DateRangePicker from '../../../control/datepicker/DateRangePicker'
import useLoading from '../../../control/loading/useLoading'
import Select from '../../../control/select/select'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import { ExpertiseFaculty } from '../../../services/lookup/types/responseLookupServiceTypes'
import useLookupService from '../../../services/lookup/useLookupService'
import useIRB from '../../../services/um/lookups/useIRB'
import useAuthenStore from '../../../stores/authen/authenStore'
import useExpertises from '../shareLogic/useExpertises'

const CustomBtn = styled(Button)(() => ({
    minWidth: '0px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
}))

const SearchCommittees: FC<{}> = () => {
    const translate = useTranslate()
    const form = useForm()
    const { irb } = useIRB()
    const authenStore = useAuthenStore()
    const defaultREC = authenStore.profile.irb ? [authenStore.profile.irb.toString()] : []
    const lutHook = useLookupService()
    const expertiseHook = useExpertises()
    const [initFaculty, setInitFaculty] = useState<ExpertiseFaculty>()
    const [initExpertise, setInitExpertise] = useState()
    const loadingHook = useLoading()

    const getLut = (rawData: any, languageKey: string) => {
        const result = rawData?.result
        return result?.map((data: any) => ({
            label: languageKey === translate.languageKey.en ? data.nameEN : data.nameTH,
            value: `${data.id}`,
        }))
    }
    const expertiseFaculty = useMemo(
        () => getLut(initFaculty, translate.languageStore.currentLanguage),
        [initFaculty, translate.languageStore.currentLanguage],
    )
    const expertise = useMemo(
        () => getLut(initExpertise, translate.languageStore.currentLanguage),
        [initExpertise, translate.languageStore.currentLanguage],
    )

    useEffect(() => {
        initLut()
    }, [])

    const initLut = async () => {
        loadingHook.loadingOpen()
        await Promise.all([
            expertiseHook.getExpertisesLUT(),
            lutHook.getExpertiseFaculty()
        ]).then((response) => {
            setInitExpertise(response[0])
            setInitFaculty(response[1])
        })
        loadingHook.loadingClose()
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <MyTextfield
                    name="keyword"
                    materialInputProps={{
                        label: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                        placeholder: `${translate.get('LABEL.SEARCH_BY_KEYWORD')}`,
                        size: 'small',
                    }}
                    onEnter={form.submit}
                />
            </Grid>
            <Grid item xs={2}>
                <Select
                    name="rec"
                    option={irb}
                    label={translate.get('UM.SETTINGDOCUMENT.SEARCH.REC')}
                    placeholder={translate.get('UM.SETTINGDOCUMENT.SEARCH.REC')}
                    size="small"
                    defaultValue={defaultREC}
                    disabled
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Autocomplete
                    name="faculty"
                    materialInputProps={{
                        label: translate.get('LABEL.FACULTY'),
                        placeholder: translate.get('LABEL.PLEASE_SELECT'),
                    }}
                    options={expertiseFaculty ?? []}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Autocomplete
                    name="expertise"
                    materialInputProps={{
                        label: translate.get('LABEL.EXPERTISE'),
                        placeholder: translate.get('LABEL.PLEASE_SELECT'),
                    }}
                    options={expertise ?? []}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <DateRangePicker
                    names={{
                        start: 'startDate',
                        end: 'endDate'
                    }}
                    label={translate.get('BUTTON.PHASE')}
                />
            </Grid>
            <Grid item xs={12}>
                <Grid container justify="flex-end" spacing={2}>
                    <Grid item>
                        <Button
                            size={'large'}
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                form.reset()
                                form.submit()
                            }}
                            color="default"
                        >
                            {translate.get('BUTTON.RESET')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <CustomBtn size={'large'} fullWidth variant="contained" onClick={form.submit} color="primary">
                            {translate.get('BUTTON.SEARCH')}
                        </CustomBtn>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SearchCommittees
